import { Box } from '@mui/material';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { OfferProgressFormatVariant } from '@ocx-app/components/OfferCard/offer-card.types';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { OfferMemberProgress } from '@ocx-app/modules/offers/earning-mechanism.types';
import { Typography, SizingMultiplier } from '@ocx/ui';
import { LinearProgress } from './linear-progress.component';
import { formatOfferProgressValue } from '../offer-progress-over-time.utils';

export const PROGRESS_BAR_TEST_ID = 'offer_membership_progress_bar';

type BarProps = OfferMemberProgress & { variant: OfferProgressFormatVariant };

export const Bar = ({ required, achieved, variant }: BarProps) => {
  return (
    <Box display="flex" flexGrow={1} alignItems="center" mr={SizingMultiplier.xs} data-testid={PROGRESS_BAR_TEST_ID}>
      <LinearProgress value={required > 0 ? (achieved / required) * 100 : 0} />
      <Typography variant="subtitle2" component="span" ml={SizingMultiplier.sm}>
        {formatOfferProgressValue({ value: achieved, variant })}
      </Typography>
      <Typography variant="subtitle2" component="span" color="text.disabled">
        /{formatOfferProgressValue({ value: required, variant })}
      </Typography>
    </Box>
  );
};
